import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import { Paginator } from "primeng/paginator";
import { Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: "app-tech-analyst-public-reports",
  templateUrl: "./tech-analyst-public-reports.component.html",
  styleUrls: ["./tech-analyst-public-reports.component.css"]
})
export class TechAnalystPublicReportsComponent implements OnInit {
  // @ViewChild('paginatorId') paginator = new Paginator();
  allResearchData;
  userDetailsObject;

  filterObj: object;
  sortListData;
  selectedSortOrder = {};
  techDomainListData: object;
  userRole;
  loggedInStatus;
  userId = "";
  hasCompanyDetails = false;
  techDomainListselected = null;

  // search
  searchKeyword = "";
  selectedDomain = "";
  searchString = "";
  sortSelectedindex = null;
  techDomainData;

  // Filter
  totalRecords = 0;
  dataLimit = 9;
  skipValue = 0;

  noResearchData: boolean;

  constructor(
    // public rolesSharedService: RolesSharedService,
    // public filterUtilService: FilterUtilService,
    // private router: Router,
    // private authenticationService: AuthenticationService,
    // private techBuyerService: TechBuyerService,
    @Inject(DOCUMENT) private document: Document
  )
  // private dataService: DataService,
  // private nickNameModalService: NickNameModalService
  {
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("outer-page");
    }

  ngOnInit() {
    // this.isLoggedIn();
    // this.userDetails();
    // this.getDomainList();
    // this.getAllResearchData();
    // this.sortListData = SortValues.list;
  }

  // isLoggedIn() {
  //   if (this.authenticationService.isLoggedIn()) {
  //     this.loggedInStatus = true;
  //     this.getRole();
  //   } else {
  //     this.loggedInStatus = false;
  //   }
  // }

  // getRole() {
  //   this.userRole = this.authenticationService.getFormattedRole();
  // }

  // userDetails() {
  //   if (window.sessionStorage.getItem("userDetails")) {
  //     this.userDetailsObject = JSON.parse(
  //       window.sessionStorage.getItem("userDetails")
  //     );
  //     this.userId = this.userDetailsObject.userId;
  //   }
  // }

  // getDomainList() {
  //   this.rolesSharedService.getTechDomainsList().subscribe(data => {
  //
  //     this.techDomainListData = data;
  //   });
  // }

  // allResearchDataFilter() {
  //   const filter: any = {};
  //   filter.filter = JSON.stringify({
  //     include: [
  //       { survey: { responses: "users" } },
  //       "domain",
  //       { likes: "user" },
  //       { comments: "user" },
  //       { ratings: "user" },
  //       { bookmark: "user" }
  //     ]
  //   });
  //   filter.limit = this.dataLimit;
  //   filter.skip = this.skipValue;
  //   filter.search = this.searchString;
  //
  //   if (this.sortSelectedindex) {
  //     filter.sort = JSON.stringify(this.sortSelectedindex);
  //   }
  //   if (this.techDomainListselected) {
  //     filter.where = JSON.stringify({
  //       techDomainId: this.techDomainListselected
  //     });
  //   }
  //
  //   return filter;
  // }

  // applyFilter() {
  //   this.dataLimit = 9;
  //   this.skipValue = 0;
  //   if (this.paginator) {
  //     this.paginator.first = 0;
  //   }
  //   this.getAllResearchData();
  // }

  // getAllResearchData() {
  //   this.rolesSharedService
  //     .getAllResearches(this.allResearchDataFilter())
  //     .subscribe(
  //       (response: any) => {
  //         window.scroll(0, 0);
  //         if (response['totalCount'] == 0) {
  //           this.noResearchData = true;
  //         } else {
  //           this.noResearchData = false;
  //         }
  //
  //         this.allResearchData = response.data;
  //         this.totalRecords = response.totalCount;
  //
  //       },
  //       error => {
  //
  //       }
  //     );
  // }

  // isAccessible(allResearchDat) {
  //   // research document click
  //   if (this.loggedInStatus && this.userRole === "tech-buyer") {
  //     if (!this.hasCompanyDetails) {
  //       this.showModal();
  //     } else {
  //       this.snapshotPageNavigation(allResearchDat);
  //     }
  //   } else if (this.loggedInStatus && (this.userRole === "tech-vendor" || this.userRole === "tech-analyst")) {
  //     this.snapshotPageNavigation(allResearchDat);
  //   } else if (!this.loggedInStatus) {
  //     swal({
  //       position: "center",
  //       type: "warning",
  //       title: "Info",
  //       showConfirmButton: false,
  //       timer: 2000,
  //       text: "Please login to continue"
  //     });
  //   }
  // }

  // refresh(evt: any) {
  //   // company details event
  //   this.getTechBuyerDetails();
  //   $("#company-details").modal("hide");
  // }

  // getTechBuyerDetails() {
  //   this.techBuyerService
  //     .getTechBuyerDetails(this.userId)
  //     .subscribe((response: any) => {
  //
  //       const modifiedUserDetails = Object.assign(
  //         JSON.parse(window.sessionStorage.getItem("userDetails")),
  //         { organization: response.organization },
  //         { techBuyerOrganization: response.techbuyerOrganization }
  //       );
  //       this.hasCompanyDetails = true;
  //       window.sessionStorage.setItem(
  //         "userDetails",
  //         JSON.stringify(modifiedUserDetails)
  //       );
  //       if (window.localStorage.getItem("rememberMeStatus")) {
  //         if (window.localStorage.getItem("rememberMeStatus") === "true") {
  //
  //           window.localStorage.setItem(
  //             "userDetails",
  //             JSON.stringify(modifiedUserDetails)
  //           );
  //         }
  //       }
  //       this.checkDetails();
  //     });
  // }

  // checkDetails() {
  //   if (
  //     !JSON.parse(window.sessionStorage.getItem("userDetails")).organization
  //   ) {
  //     this.hasCompanyDetails = false;
  //   } else {
  //     this.hasCompanyDetails = true;
  //   }
  // }

  // likeClick(postData, index) {
  //   if (this.loggedInStatus) {
  //     if (this.userDetailsObject.nickName) {
  //       const likeObject = {
  //         postId: postData.id,
  //         postType: "research_document",
  //         userId: this.userId
  //       };
  //       this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
  //         if (likeResponse["liked"]) {
  //           // case when user is liked and updated in server
  //           postData.liked = true;
  //           postData.likes += 1;
  //         } else if (!likeResponse["liked"]) {
  //           // case when user is not liked and updated in server
  //           postData.liked = false;
  //           if (postData.likes != 0) {
  // postData.likes -= 1;
  // }
  //         }
  //       })
  //     } else {
  //
  //       this.nickNameModalService.openNickNameModal();
  //       this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
  //         if (response) {
  //           this.userDetails();
  //         }
  //       })
  //     }
  //   } else {
  //     swal({
  //       position: "center",
  //       type: "warning",
  //       title: "Info",
  //       showConfirmButton: false,
  //       timer: 2000,
  //       text: "Please login to continue"
  //     });
  //   }
  // }

  // showModal() {
  //   $("#company-details").modal("show");
  // }

  // paginate(event: any) {
  //
  //   this.dataLimit = event.rows;
  //   this.skipValue = event.first;
  //   this.getAllResearchData();
  // }

  // snapshotPageNavigation(allResearchDat) {
  //   let researchDataModel = {
  //     id: allResearchDat.id,
  //     title: allResearchDat.title,
  //     participants: allResearchDat.participants,
  //     ratings: allResearchDat.ratings,
  //     createdAt: allResearchDat.createdAt,
  //     synopsis: allResearchDat.synopsis,
  //     isParticipated: allResearchDat.isParticipated,
  //     surveyId: allResearchDat.survey.id
  //   };
  //   this.dataService.researchDocumentDataService(researchDataModel);
  //   this.router.navigate([`${this.userRole}/research-snapshot`]);
  // }

  // featureUnderConstructionNavigation() {
  //   if (this.loggedInStatus) {
  //     this.router.navigate([`${this.userRole}/under-construction`]);
  //   } else {
  //     this.router.navigate([`under-construction`]);
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tech-analyst-public-reports/tech-analyst-public-reports.component.ts